/* global CriteriaHelper */

// Hooks
import { useCriteriaStorePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStorePredicate';

// Types
import { ruleEditorViewPartCommonProps } from '../../types';

export const FunctionGlobalResource = ({ id, ...props }) => {
    const part = useCriteriaStorePredicate(id);
    const config = {
        Global: CriteriaHelper.partTypes.globalResource,
        Function: CriteriaHelper.partTypes.functionResource
    }[part.resourceType];

    return config.isValid(part) ? config.label(part) : null;
};

export default FunctionGlobalResource;

FunctionGlobalResource.propTypes = {
    ...ruleEditorViewPartCommonProps
};
